import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

import { injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { SportsThemedToastDirective, ToastVariant } from '@frontend/sports/common/ui/sports-themed-toast';
import { DsButtonIcon } from '@frontend/ui/button-icon';
import { DsToast } from '@frontend/ui/toast';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { ToasterModel } from './toaster.service';

@Component({
    selector: 'ms-toaster',
    templateUrl: './toaster.component.html',
    styleUrl: './toaster.component.scss',
    imports: [IconCustomComponent, DsToast, SportsThemedToastDirective, DsButtonIcon],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'toaster',
    },
})
export class ToasterComponent implements OnInit {
    public toast = inject<ToasterModel>(MAT_SNACK_BAR_DATA);
    private readonly currentTheme = injectCurrentTheme();
    readonly toastVarient: ToastVariant = {
        'bwin': 'strong',
        'premium-dark': 'strong',
        'mgm-dice': 'strong',
        'bwin-dark': 'strong',
        'betboo-br': 'strong',
        'sportingbet-br': 'strong',
    };
    strongInverse = false;

    ngOnInit(): void {
        this.strongInverse = this.toastVarient[this.currentTheme] === 'strong';
    }
}
